export default __webpack_public_path__ + "static/media/IMG-20241005-WA0030.d966e749.jpg";